export default __webpack_public_path__ + "app/images/2327e310a72ef7a93aa0af70b6b7f4f1.svg";